import React from "react";
// import Link
import { Link } from "react-router-dom";
// Import Icon
import Tags from "../../assets/img/icon/tag.png";
import Map from "../../assets/img/icon/map.png";
import Cal from "../../assets/img/icon/cal.png";
import Mail from "../../assets/img/icon/email.png";
import Phone from "../../assets/img/icon/phone.png";

// Import Social Icom
import facebook from "../../assets/img/icon/facebook.png";
import instagram from "../../assets/img/icon/instagram.png";
import twitter from "../../assets/img/icon/twitter.png";
import linkedin from "../../assets/img/icon/linkedin.png";

// Import Img
import rece1 from "../../assets/img/sidebar/rec-donet-1.png";
import rece2 from "../../assets/img/sidebar/rec-donet-2.png";
import rece3 from "../../assets/img/sidebar/rec-donet-3.png";

const EventDetailSidebar = () => {
  const OrganizerData = [
    {
      img: rece1,
      name: "Mike richard",
      desnation: "Managing director",
      group: "Care NGO ltd.",
    },
    {
      img: rece2,
      name: "Jenifar lawrence",
      desnation: "Entrepreneur",
      group: "Entrepreneur",
    },
    {
      img: rece3,
      name: "David jovan",
      desnation: "Manager",
      group: "ABC Company",
    },
  ];
  // The technical name for starting each word with a capital letter is "Title Case" or "Capitalization".
  // Here is your modified code with the first letters capitalized:

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <div className="sidebar_first">
            <div className="sidebar_boxed">
              <div className="sidebar_heading_main">
                <h3>Naira</h3>
              </div>

              <div className="event_details_list">
                <ul>
                  <li>
                    <img src={Tags} alt="Icon" /> Account Name:{" "}
                    <span>
                      Cradle Care Foundation For Vulnerable Women And Children
                    </span>
                  </li>
                  <li>
                    <img src={Map} alt="Icon" /> Bank: <span>GT Bank</span>
                  </li>
                  <li>
                    <img src={Cal} alt="Icon" /> Account Number:{" "}
                    <span>3001820083</span>
                  </li>
                  {/* <li>
                                    <img src={Mail} alt="Icon" /> IFSC Code: <span>ABC0001234</span>
                                </li> */}
                  <li>
                    <img src={Phone} alt="Icon" /> Branch: <span>Nigeria</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="sidebar_first">
            <div className="sidebar_boxed">
              <div className="sidebar_heading_main">
                <h3>USD / Domiciliary</h3>
              </div>
              <div className="event_details_list">
                <ul>
                  <li>
                    <img src={Tags} alt="Icon" /> Account Name:{" "}
                    <span>
                      Cradle Care Foundation For Vulnerable Women And Children
                    </span>
                  </li>
                  <li>
                    <img src={Map} alt="Icon" /> Bank: <span>GT Bank</span>
                  </li>
                  <li>
                    <img src={Cal} alt="Icon" /> Account Number:{" "}
                    <span>3001820100 </span>
                  </li>
                  {/* <li>
                                                        <img src={Mail} alt="Icon" /> IFSC Code: <span>ABC0001234</span>
                                                    </li> */}
                  <li>
                    <img src={Phone} alt="Icon" /> Branch: <span>Nigeria</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventDetailSidebar;
